angular.module('impactx.rfx').controller('RFXOfferSupportCtrl', [
    '$scope',
    'RFXBuyerService',
    '$routeParams',
    'ToolbarService',
    'TranslationService',
    'ToastService',
    '$route',
    'dataGen',
    '$redirect',
    '$copyToClipboard',
    'ColorUtilService',
    'RFXSupplierService',
    '$mdDialog',
    'ConfirmationService',
    'BackService',
    'ProductEuelService',
    RFXOfferSupportCtrl
]);

function RFXOfferSupportCtrl($scope, RFXBuyerService, $routeParams, ToolbarService, TranslationService, ToastService, $route,
                             dataGen, $redirect, $copyToClipboard, ColorUtilService, RFXSupplierService, $mdDialog, ConfirmationService,
                             BackService, ProductEuelService) {
    var self = this;
    $scope.productDataSheetLabel = TranslationService.get("productDataSheet");
    self.productEuelService = ProductEuelService;
    self.offSetForBasketItemGroupColor = 15;
    self.getGroupColor = function (item) {
        if (item.basketItemGroupNumber) {
            return ColorUtilService.getColor(item.basketItemGroupId + self.offSetForBasketItemGroupColor);
        }
        return 'transparent';
    };

    self.extendBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '6px';
        });
    };

    self.shrinkBorderBasketItemGroup = function (item) {
        var id = item.basketItemGroupId || 0;
        var element = document.getElementsByClassName('basket-item-group-' + (id + self.offSetForBasketItemGroupColor));
        var jqElement = angular.element(element);
        angular.forEach(jqElement, function (aElement) {
            aElement.style['border-left-width'] = '3px';
        });
    };

    self.viewBasketItemGroup = function (event, item, contract) {
        event.stopPropagation();
        var basketItemGroupId = item.basketItemGroupId;
        var groupItems = findBasketItemGroupItems(item.basketItemGroupId, contract);
        RFXSupplierService.showFreeformOfferDialog(event, item.basketItemGroupId, $routeParams.rfqsId, contract.supplierId,
            groupItems, item.basketItemGroupData, contract.id, contract.lotId, true, [contract]);
    };

    function findBasketItemGroupItems (identifier, contract) {
        return contract.items.filter(function (item) {
            return item.basketItemGroupId === identifier;
        });
    }

    self.selectedItems = [];

    RFXBuyerService.getRFQSItemData($routeParams.rfqsId).then(function (response) {
        if (response && response.data) {
            self.data = response.data;
            self.trns = response.trns;
            self.trns.addToBasket = TranslationService.get('addToBasket');
        }
        defineButtons();
    });

    self.selectPosition = function (position) {
        var index = self.selectedItems.indexOf(position);
        if (index < 0) {
            self.selectedItems.push(position);
        }
        else {
            self.selectedItems.splice(index, 1);
        }
    };

    self.isSelected = function (item) {
        return self.selectedItems.indexOf(item) >= 0;
    };

    self.hasOneSelectedItem = function() {
        return self.selectedItems.length == 1;
    };

    self.isInformation = function (item) {
        var policy;
        if (item.smartForm) {
            policy = self.getSmartFormPolicy(item.smartForm.identifier);
        }
        return item.isInformation || (policy && policy.isInformation);
    };

    self.getSmartFormPolicy = function (id) {
        var policies = self.data.smartFormPolicies;
        if (typeof id === 'string') {
            for (var key in policies) {
                if (policies.hasOwnProperty(key) &&
                    policies[key].identifier === id) {
                    return policies[key];
                }
            }
        }
        else if (typeof id === 'number' && !isNaN(id)) {
            return policies[id];
        }
    }

    self.viewPosition = function (event) {
        if (self.selectedItems.length == 1) {
            var selectedItem = self.selectedItems[0];
            RFXBuyerService.showViewPositionDialog(event, self.id, selectedItem, self.trns, self.data.smartFormTemplates);
        }
    };

    self.hideButtons = true;

    function defineButtons() {
        var buttonDefinition = [
            {
                label: self.trns.details,
                action: self.viewPosition,
                type: 'dialogaction',
                condition: self.hasOneSelectedItem
            },
            {
                label: self.trns.requestDetails,//"Anfragedetails",
                linkFunction: getDetailLink,
                type: 'link',
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function getDetailLink() {
        return "rfx/requestsupport/" + self.data.headerId;
    }
}